import { Linkedin, Facebook, Twitter, Link2 } from "lucide-react";
import { toast } from "sonner";

const SITE_URL = "https://iperammortamentovalore.com/";
const SHARE_TEXT = "Calcola i benefici fiscali dell'iperammortamento con lo Studio Ingegneria Valore";

export default function SocialShare() {
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(SITE_URL);
      toast.success("Link copiato negli appunti");
    } catch {
      toast.error("Impossibile copiare il link");
    }
  };

  const items = [
    {
      label: "Condividi su LinkedIn",
      testid: "share-linkedin",
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(SITE_URL)}`,
      icon: Linkedin,
    },
    {
      label: "Condividi su Facebook",
      testid: "share-facebook",
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(SITE_URL)}`,
      icon: Facebook,
    },
    {
      label: "Condividi su X (Twitter)",
      testid: "share-twitter",
      href: `https://twitter.com/intent/tweet?url=${encodeURIComponent(SITE_URL)}&text=${encodeURIComponent(SHARE_TEXT)}`,
      icon: Twitter,
    },
  ];

  return (
    <div className="flex items-center gap-2" data-testid="social-share">
      <span className="text-white/60 text-xs uppercase tracking-widest hidden sm:inline">Condividi</span>
      {items.map((it) => (
        <a
          key={it.testid}
          href={it.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={it.label}
          data-testid={it.testid}
          className="w-9 h-9 rounded-full border border-white/15 text-white/70 hover:text-white hover:border-brand hover:bg-brand/20 inline-flex items-center justify-center transition"
        >
          <it.icon className="w-4 h-4" />
        </a>
      ))}
      <button
        type="button"
        onClick={copyLink}
        aria-label="Copia link del sito"
        data-testid="share-copy"
        className="w-9 h-9 rounded-full border border-white/15 text-white/70 hover:text-white hover:border-brand hover:bg-brand/20 inline-flex items-center justify-center transition"
      >
        <Link2 className="w-4 h-4" />
      </button>
    </div>
  );
}
